﻿/*!
 * Round to the nearest whole number
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Number|String} num       The numer to round
 * @param  {Number}        precision The whole number to round to (ex. 10, 100, 1000)
 * @return {String}                  The rounded, delimited number
 */
const round = function (num, precision) {
	num = parseFloat(num);
	if (!precision) return num.toLocaleString();
	return (Math.round(num / precision) * precision).toString();
};

/*!
 * Round down to the nearest whole number
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Number|String} num       The numer to round
 * @param  {Number}        precision The whole number to round to (ex. 10, 100, 1000)
 * @return {String}                  The rounded, delimited number
 */
const roundDown = function (num, precision) {
	num = parseFloat(num);
	if (!precision) return num.toLocaleString();
	return (Math.floor(num / precision) * precision).toString();
};

/*!
 * Round up to the nearest whole number
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Number|String} num       The numer to round
 * @param  {Number}        precision The whole number to round to (ex. 10, 100, 1000)
 * @return {String}                  The rounded, delimited number
 */
const roundUp = function (num, precision) {
	num = parseFloat(num);
	if (!precision) return num.toLocaleString();
	return (Math.ceil(num / precision) * precision).toString();
};

const roundInputToStep = function (input) {
	console.log(`roundInputToStep()                        ${input.id} ${input.value}`);
	const val = Number(input.value);
	const step = Number(input.step);

	let result = val;
	if (!isNaN(val) && !isNaN(step)) {
		const roundedVal = round(val, step);
		result = roundedVal == 0 ? '' : roundedVal;
	}
	return result;
}
function sanitiseNumber(x) {
	if (isNaN(x)) return NaN;
	return x;
}

function remCalc(px, base = 16) {
	let tempPx = px
	if (typeof px === 'string' || px instanceof String)
		tempPx = tempPx.replace('px', '')

	tempPx = parseInt(tempPx)
	return (1 / base) * tempPx + 'rem'
}

export { round, roundDown, roundUp, roundInputToStep, sanitiseNumber, remCalc }